import { axiosInstance } from "@/api/apiClient";
import {
  ReceiverLineApi,
  ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtensionRequest,
  ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLineRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new ReceiverLineApi(undefined, BASE_API, axiosInstance);

export const getReceiverLineExtensions = async (
  payload: ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverExtensionRequest
) => {
  return api.telephonyViewsNinjaNumberReceiverLineListReceiverExtension.bind(
    api
  )(payload);
};

export const getReceiverLineList = async (
  payload: ReceiverLineApiTelephonyViewsNinjaNumberReceiverLineListReceiverLineRequest
) => {
  return api.telephonyViewsNinjaNumberReceiverLineListReceiverLine.bind(api)(
    payload
  );
};
